import { Filters } from "@shopify/polaris";
import React from "react";

import { reducerFn } from "../../helper";
import useTimeout from "../../hooks/useTimeout";
import { useAmazonIdeaTemplateCtx } from "./context";

export default function AmazonIdeaTemplateFilter() {
    const [state, setState] = React.useReducer(reducerFn, {
        search: "",
    });

    const { setFilter } = useAmazonIdeaTemplateCtx();

    const [setDelay] = useTimeout();
    const handleQueryChange = React.useCallback((search) => {
        setState({ search });

        setDelay(() => {
            setFilter({ search });
        });
    }, []);

    const handleQueryClear = React.useCallback(() => {
        setState({ search: "" });

        setDelay(() => {
            setFilter({ search: "" });
        });
    }, []);

    const handleClearAll = React.useCallback(() => {
        handleQueryClear();
    }, []);

    const filters = [];
    return (
        <Filters
            filters={filters}
            appliedFilters={[]}
            queryPlaceholder="Search Amazon Idea Template"
            queryValue={state.search}
            onClearAll={handleClearAll}
            onQueryChange={handleQueryChange}
            onQueryClear={handleQueryClear}
        />
    );
}
